import { render, staticRenderFns } from "./starredReviews.vue?vue&type=template&id=56dfcd87"
import script from "./starredReviews.vue?vue&type=script&lang=js"
export * from "./starredReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports